import { SelectOption } from "src/shared/config";

export const languageOptions: SelectOption[] = [
  {
    label: "English",
    value: "us",
  },
  {
    label: "Deutsch",
    value: "de",
  },
];
